/* eslint-disable import/no-duplicates */
import React, { useState } from 'react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { Chart } from 'react-google-charts';
import { useCurrentEffect } from '../../../../../../../../lib/use-current-effect';

import {
  getMeasurementsByDay,
  getMeasurementsByDateRange,
} from '../../../../../../../../services/metrics';
import { usePatient } from '../../../../../../../../hooks/patient';

import Default, { ShowScreenType } from '../_Default';
import { ChartsProps } from '../../MetricView';
import { MetricTypeEnum } from '../../../../../../../../enums/MetricTypeEnum';

const HeartRateChart: React.FC<ChartsProps> = ({ dateRange }) => {
  const { patient } = usePatient();

  const [showScreen, setShowScreen] = useState<ShowScreenType>('loading');
  const [graphData, setGraphData] = useState<(string | number)[][]>([
    ['00:00', 0],
  ]);

  useCurrentEffect(
    (isCurrent) => {
      (() => {
        if (patient?.id) {
          if (isCurrent()) {
            setShowScreen('loading');
          }

          const { startDate, endDate } = dateRange;

          if (startDate === endDate) {
            getMeasurementsByDay({
              patientId: patient.id,
              metricType: MetricTypeEnum.HEART_BEAT_RATE,
              dateFilter: startDate,
            })
              .then((response) => {
                if (isCurrent()) {
                  if (response.length > 0) {
                    const result = response.map(
                      ({ heartBeatRate, mensuramentDate }) => [
                        format(new Date(mensuramentDate), 'HH:mm', {
                          locale: ptBR,
                        }),
                        heartBeatRate,
                      ],
                    );

                    setShowScreen('chart');
                    setGraphData(result);
                  } else {
                    setShowScreen('noData');
                  }
                }
              })
              .catch(() => {
                if (isCurrent()) {
                  setShowScreen('noData');
                }
              });
          } else {
            getMeasurementsByDateRange({
              patientId: patient.id,
              metrics: MetricTypeEnum.HEART_BEAT_RATE,
              startDate,
              endDate,
            })
              .then((response) => {
                if (isCurrent()) {
                  if (response.length > 0) {
                    const result = response.map(
                      ({ heartBeatRate, mensuramentDate }) => [
                        format(new Date(mensuramentDate), "dd'/'MM", {
                          locale: ptBR,
                        }),
                        heartBeatRate,
                      ],
                    );

                    setShowScreen('chart');
                    setGraphData(result);
                  } else {
                    setShowScreen('noData');
                  }
                }
              })
              .catch(() => {
                if (isCurrent()) {
                  setShowScreen('noData');
                }
              });
          }
        }
      })();
    },
    [dateRange, patient],
  );

  return (
    <Default showScreen={showScreen}>
      <Chart
        width="100%"
        height="300px"
        chartType="AreaChart"
        options={{
          legend: 'none',
          colors: ['#2D9CDB'],
          vAxis: {
            ticks: [60, 100, 140],
          },
          series: {
            0: { curveType: 'function' },
            chartArea: { left: 0, right: 0 },
          },
        }}
        data={[['h', 'BPM'], ...graphData]}
        rootProps={{ 'data-testid': '2' }}
      />
    </Default>
  );
};

export default HeartRateChart;
